<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content>
			<template #content>
				<div class="columns column6">
					<h1>{{ page.header }}</h1>
				</div>
				<div class="columns column6">
					<div v-parse-links v-html="page.mainContent" />
				</div>
			</template>
		</main-content>

		<room-detail-block
			:title="page.title || page.header"
			:content="page.content"
			:book-button-label="defaults[locale].website.book"
			:package-i-d="page.bookingID"
			:image="{
				image: page.sideImage,
				imageWebp: page.sideImageWebp,
				imagePortrait: page.sideImagePortrait,
				imagePortraitWebp: page.sideImagePortraitWebp,
			}"
		/>

		<section class="main-content room-info">
			<div v-if="(page.extras && page.extras.length) || page.extraContent" class="row background-light">
				<div v-if="page.extras && page.extras.length" class="columns column12">
					<h3>{{ $t('included') }}</h3>
					<div class="room-icons">
						<div v-for="facility in page.extras" :key="facility.id" class="icon-holder">
							<font-awesome-icon :icon="`fal fa-${facility.icon}`" size="1x" />
							<span>{{ facility.content }}</span>
						</div>
					</div>
				</div>
				<div v-if="page.extraContent" class="columns column4">
					<div v-parse-links v-html="page.extraContent" />
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
</script>

<style lang="scss">
.package-prefooter {
	padding: 50px 0;
	background: var(--package-banner-color);
	color: #fff;
}

.package-prefooter h2 {
	color: #fff;
}

.extra-image {
	width: 100%;
	max-width: 600px;
	margin: 20px auto 0;
}

.package-icons {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: stretch;
}

.package-icon {
	width: 46%;
	background: #fff;
	padding: 40px 30px;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	text-align: center;
	margin: 10px auto;
}

.package-icon i,
.package-icon svg {
	color: var(--package-banner-color);
	font-size: 66px;
	margin: 0 auto 40px;
}

.package-icon span {
	width: 100%;
	font-size: 14px;
}

.room-icons {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: flex-start;
	margin: 0 0 40px;
	gap: 30px;
}

.icon-holder {
	color: #000;
	display: flex;
	margin: 10px 0;

	i,
	svg {
		margin: 0 5px 0 0;
	}
}

@media (max-width: 920px) {
	.package-icons {
		width: 100%;
	}
}

@media (max-width: 680px) {
	.package-icon {
		padding: 30px 20px;
		width: 48%;
	}

	.package-icon i,
	.package-icon svg {
		font-size: 58px;
	}

	.package-icon span {
		font-size: 14px;
	}
}
</style>
